import {map} from 'lodash';
import './index.scss';

export default function CommonQuestionsPage() {

  return (
    <div className="container my-5 commonQuestionPage">
      <h2>Common Questions</h2>
      {renderCommonQuestions()}
    </div>
  );
}

function renderCommonQuestions() {
  const items = [
    {
      id: 1,
      question: 'What is Fuzzy Score?',
      answer: 'Fuzzy Score provides a clear, data-driven view of GitHub activity, ' +
          'including language usage and commit frequency – all in one clean, ' +
          'interactive dashboard. Whether you\'re hiring for a technical team or exploring a candidate\'s ' +
          'long-term growth, Fuzzy Score helps you go beyond the resume and into real developer behavior.',
    },
    {
      id: 2,
      question: 'Who can benefit from using Fuzzy Score?',
      answer: 'Fuzzy Score is ideal for software developers, engineers, hiring managers, and recruiters.',
    },
    {
      id: 3,
      question: 'What’s the benefit for software developers and engineers to sign up for Fuzzy Score?',
      answer: 'By creating an account on Fuzzy Score, you can showcase your tech stack and link your ' +
          'GitHub repositories. This makes it easy for hiring managers and recruiters to view your ' +
          'technical skills and project activity at a glance. With your work visible and up to date, ' +
          'they can reach out to you faster for relevant opportunities.',
    },
    {
      id: 4,
      question: 'What’s the benefit for hiring managers and recruiters to sign up for Fuzzy Score?',
      answer: 'Hiring managers and recruiters can add their company’s tech stack, ' +
          'making it easier for developers and engineers to discover and align with the ' +
          'technologies they use. Additionally, recruiters get access to more detailed insights about ' +
          'developers—including their GitHub activity and tech stack—helping them make more ' +
          'informed hiring decisions.',
    },
  ];
  
  return (
    <div className="accordion my-accordion" id="myAccordion">
      {map(items, (item) => (
        <div className="accordion-item" key={item.id}>
          <h2 className="accordion-header" id={`heading--${item.id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse--${item.id}`}
              aria-expanded="false"
              aria-controls={`collapse--${item.id}`}
            >
              <strong>{item.question}</strong>
            </button>
          </h2>
          <div
            id={`collapse--${item.id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading--${item.id}`}
            data-bs-parent="#myAccordion"
          >
            <div className="accordion-body my-answer">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
